import { withInstall } from "../utils/index.mjs";
import _Grid from "./Grid.mjs";
const Grid = withInstall(_Grid);
var stdin_default = Grid;
import { gridProps } from "./Grid.mjs";
export {
  Grid,
  stdin_default as default,
  gridProps
};
